// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var MM_proof_tree = require("./MM_proof_tree.bs.js");
var Belt_MutableMap = require("rescript/lib/js/belt_MutableMap.js");
var Belt_MutableSet = require("rescript/lib/js/belt_MutableSet.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var Belt_MutableStack = require("rescript/lib/js/belt_MutableStack.js");

function exprSourceToDto(src, exprToIdx) {
  if (typeof src === "number") {
    return /* VarType */0;
  }
  if (src.TAG === /* Hypothesis */0) {
    return {
            TAG: /* Hypothesis */0,
            label: src.label
          };
  }
  var args = src.args;
  if (args.some(function (arg) {
          return MM_proof_tree.pnIsInvalidFloating(arg) ? Belt_Option.isNone(MM_proof_tree.pnGetProof(arg)) : false;
        })) {
    return ;
  } else {
    return {
            TAG: /* Assertion */1,
            args: args.map(function (arg) {
                  var idx = Belt_HashMap.get(exprToIdx, MM_proof_tree.pnGetExpr(arg));
                  if (idx !== undefined) {
                    return idx;
                  }
                  throw {
                        RE_EXN_ID: MM_parser.MmException,
                        _1: {
                          msg: "exprSourceToDto: cannot get idx by expr."
                        },
                        Error: new Error()
                      };
                }),
            label: src.frame.label
          };
  }
}

function proofNodeToDto(node, exprToIdx) {
  return {
          expr: MM_proof_tree.pnGetExpr(node),
          exprStr: MM_proof_tree.pnGetExprStr(node),
          parents: Belt_Option.map(MM_proof_tree.pnGetParents(node), (function (parents) {
                  return parents.map(function (__x) {
                                  return exprSourceToDto(__x, exprToIdx);
                                }).filter(Belt_Option.isSome).map(Belt_Option.getExn);
                })),
          proof: Belt_Option.flatMap(MM_proof_tree.pnGetProof(node), (function (__x) {
                  return exprSourceToDto(__x, exprToIdx);
                }))
        };
}

function collectAllExprs(tree, roots) {
  var nodesToProcess = Belt_MutableStack.make(undefined);
  roots.forEach(function (expr) {
        Belt_MutableStack.push(nodesToProcess, MM_proof_tree.ptGetOrCreateNode(tree, expr));
      });
  var processedNodes = Belt_HashSet.make(100, MM_context.ExprHash);
  var res = Belt_HashMap.make(100, MM_context.ExprHash);
  var saveNodesFromSrc = function (src) {
    if (typeof src === "number") {
      return ;
    }
    if (src.TAG === /* Hypothesis */0) {
      return ;
    }
    src.args.forEach(function (arg) {
          if (!MM_proof_tree.pnIsInvalidFloating(arg) || Belt_Option.isSome(MM_proof_tree.pnGetProof(arg))) {
            return Belt_MutableStack.push(nodesToProcess, arg);
          }
          
        });
  };
  while(!Belt_MutableStack.isEmpty(nodesToProcess)) {
    var curNode = Belt_Option.getExn(Belt_MutableStack.pop(nodesToProcess));
    var curExpr = MM_proof_tree.pnGetExpr(curNode);
    if (!Belt_HashSet.has(processedNodes, curExpr)) {
      Belt_HashSet.add(processedNodes, curExpr);
      Belt_HashMap.set(res, curExpr, Belt_HashMap.size(res));
      Belt_Option.forEach(MM_proof_tree.pnGetParents(curNode), (function (__x) {
              __x.forEach(saveNodesFromSrc);
            }));
      Belt_Option.forEach(MM_proof_tree.pnGetProof(curNode), saveNodesFromSrc);
    }
    
  };
  return res;
}

function proofTreeToDto(tree, stmts) {
  var exprToIdx = collectAllExprs(tree, stmts);
  var nodes = new Array(Belt_HashMap.size(exprToIdx));
  Belt_HashMap.forEach(exprToIdx, (function (expr, idx) {
          Caml_array.set(nodes, idx, proofNodeToDto(MM_proof_tree.ptGetOrCreateNode(tree, expr), exprToIdx));
        }));
  var newVars = MM_proof_tree.ptGetCopyOfNewVars(tree);
  var disj = MM_proof_tree.ptGetCopyOfDisj(tree);
  var exprToStr = MM_proof_tree.ptGetExprToStr(tree);
  var dbg;
  if (exprToStr !== undefined) {
    var dbgNewVars = newVars.map(Curry.__1(exprToStr));
    var dbgDisj = [];
    MM_context.disjForEach(disj, (function (n, m) {
            dbgDisj.push(Curry._1(exprToStr, [
                      n,
                      m
                    ]));
          }));
    dbg = {
      newVars: dbgNewVars,
      disj: dbgDisj
    };
  } else {
    dbg = undefined;
  }
  return {
          newVars: newVars,
          disj: disj,
          nodes: nodes,
          dbg: dbg
        };
}

function createProofTable(tree, root) {
  var processedExprs = Belt_MutableSet.make(MM_context.ExprCmp);
  var exprToIdx = Belt_MutableMap.make(MM_context.ExprCmp);
  var tbl = [];
  Expln_utils_data.traverseTree(undefined, root, (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match !== "number") {
              if (match.TAG === /* Hypothesis */0 || Belt_MutableSet.has(processedExprs, n.expr)) {
                return ;
              } else {
                return match.args.map(function (idx) {
                            return Caml_array.get(tree.nodes, idx);
                          });
              }
            }
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "VarType is not supported in createProofTable [1]."
                  },
                  Error: new Error()
                };
          }
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot create proofTable from an unproved proofNodeDto [1]."
                },
                Error: new Error()
              };
        }), undefined, (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match === "number") {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "VarType is not supported in createProofTable [2]."
                    },
                    Error: new Error()
                  };
            }
            if (match.TAG === /* Hypothesis */0 && Belt_Option.isNone(Belt_MutableMap.get(exprToIdx, n.expr))) {
              var idx = tbl.push({
                    expr: n.expr,
                    proof: {
                      TAG: /* Hypothesis */0,
                      label: match.label
                    }
                  }) - 1 | 0;
              Belt_MutableMap.set(exprToIdx, n.expr, idx);
            }
            
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot create proofTable from an unproved proofNodeDto [2]."
                  },
                  Error: new Error()
                };
          }
        }), (function (param, n) {
          var match = n.proof;
          if (match !== undefined) {
            if (typeof match === "number") {
              throw {
                    RE_EXN_ID: MM_parser.MmException,
                    _1: {
                      msg: "VarType is not supported in createProofTable [3]."
                    },
                    Error: new Error()
                  };
            }
            if (match.TAG !== /* Hypothesis */0 && Belt_Option.isNone(Belt_MutableMap.get(exprToIdx, n.expr))) {
              var idx = tbl.push({
                    expr: n.expr,
                    proof: {
                      TAG: /* Assertion */1,
                      args: match.args.map(function (nodeIdx) {
                            return Belt_Option.getWithDefault(Belt_MutableMap.get(exprToIdx, Caml_array.get(tree.nodes, nodeIdx).expr), -1);
                          }),
                      label: match.label
                    }
                  }) - 1 | 0;
              Belt_MutableMap.set(exprToIdx, n.expr, idx);
            }
            
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot create proofTable from an unproved proofNodeDto [3]."
                  },
                  Error: new Error()
                };
          }
        }), undefined);
  return tbl;
}

exports.proofTreeToDto = proofTreeToDto;
exports.createProofTable = createProofTable;
/* MM_context Not a pure module */
